import React, { FC, RefAttributes, forwardRef } from 'react';
import { FieldRenderProps as WrappedFieldProps } from 'react-final-form';
import { EntryProps, Error } from '@trip-ux/components';

export const GenericInputError: FC<WrappedFieldProps<string> & EntryProps & RefAttributes<HTMLInputElement>> =
  forwardRef(({ meta }, ref) => (
    <div>
      <Error errors={meta.touched ? meta.error : undefined} />
    </div>
  ));
GenericInputError.displayName = 'GenericInputError';
